import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import Message from './Message';
interface FunArg {
  content: string | ReactNode;
  duration?: number;
}
interface messageProps {
  dom: HTMLDivElement | null;
  success(arg: FunArg | string): void;
  error(arg: FunArg | string): void;
  warning(arg: FunArg | string): void;
  info(arg: FunArg | string): void;
}
const message: messageProps = {
  dom: null,
  success(params) {
    const content = typeof params === 'string' ? params : params.content;
    const duration = typeof params === 'string' ? 2000 : params.duration;
    // 创建一个dom
    this.dom = document.createElement('div');
    // 定义组件，
    const JSXdom = (
      <Message content={content} duration={duration} type="success"></Message>
    );
    // 渲染DOM
    ReactDOM.render(JSXdom, this.dom);
    // 置入到body节点下
    document.body.appendChild(this.dom);
  },
  error(params) {
    const content = typeof params === 'string' ? params : params.content;
    const duration = typeof params === 'string' ? 2000 : params.duration;
    this.dom = document.createElement('div');
    const JSXdom = (
      <Message content={content} duration={duration} type="error"></Message>
    );
    ReactDOM.render(JSXdom, this.dom);
    document.body.appendChild(this.dom);
  },
  warning(params) {
    const content = typeof params === 'string' ? params : params.content;
    const duration = typeof params === 'string' ? 2000 : params.duration;
    this.dom = document.createElement('div');
    const JSXdom = (
      <Message content={content} duration={duration} type="warning"></Message>
    );
    ReactDOM.render(JSXdom, this.dom);
    document.body.appendChild(this.dom);
  },
  info(params) {
    const content = typeof params === 'string' ? params : params.content;
    const duration = typeof params === 'string' ? 2000 : params.duration;
    this.dom = document.createElement('div');
    const JSXdom = (
      <Message content={content} duration={duration} type="info"></Message>
    );
    ReactDOM.render(JSXdom, this.dom);
    document.body.appendChild(this.dom);
  },
};

export default message;
